<template>
  <div class="calendar__wrap MSCalendar">
    <FullCalendar
        ref="capi"
        :options="options"
    />
  </div>
</template>

<script>
import FullCalendar from '@/calendar/vue/dist/main'; // Должен быть всегда вверху. Если сомневаешься тогда пойдешь на парашу потому, что так работате JS
import interactionPlugin from '@/calendar/interaction';
import resourceTimeGridPlugin from '@/calendar/resource-timegrid';

export default {
  name: "MCalendar",
  components: {
    FullCalendar
  },
  mounted () {
    this.api = this.$refs.capi.getApi()
    this.resize();
    this.$emit('setApi', this.api)
  },
  data () {
    return {
      specialization: null,
      offset: 0,
      api: null,
      options: {
        plugins: [interactionPlugin, resourceTimeGridPlugin],
        initialView: 'timeGridWeek',
        editable: false,
        locale: 'ru',
        selectable: true,
        windowResize: this.resize,
        eventAdd: () => this.$emit('eventAdd'),
        select: e => {
          e.specialization = this.specialization;
          this.$emit ( 'select',e)
        },
        unselect: e => {
          this.overlapId = null;
          this.$emit ( 'unselect', e )
        },
        selectAllow: (e) => {
          return e.start > Date.now() && this.$moment(e.start).format('YYYY-MM-DD') == this.$moment(e.end).format('YYYY-MM-DD')
        },
        selectOverlap:(e) => {
          this.specialization = e.extendedProps.specialization
          return e.display === 'background';
        },
        eventClick: e => {
          if(e.event.display != 'background') this.$emit ( 'eventClick', e )
        },
        headerToolbar: {
          start: '',
          end: ''
        },
        buttonText: {
          today: 'Сегодня'
        },
        titleFormat: {
          day: 'numeric',
          month: 'long',
          year: 'numeric'
        },
        unselectCancel: '.popup',
        firstDay: 1,
        views: {
          timeGridWeek: {
            type: 'timeGrid',
            duration: { week: 1 },
            buttonText: 'Неделя'
          }
        },
        height: 'auto',
        resources: [],
        slotLabelFormat: {
          hour: 'numeric',
          minute: '2-digit',
          omitZeroMinute: false,
          meridiem: 'short'
        },
        resourceAreaColumns: [
          {
            width: '152px'
          }
        ],
        nowIndicator: true,
        nowIndicatorClassNames: ['week'],
        displayEventTime: false,
        allDaySlot: false,
        slotMinTime: '10:00:00',
        slotMaxTime: '22:00:00'
      },
    }
  },
  methods: {
    resize(){
      if(window.innerWidth < 600){
        this.api.changeView('timeGridDay')
      }else{
        this.api.changeView('timeGridWeek')
      }
      this.$emit('mobile', window.innerWidth < 600)
    },
    today () {
      if(this.api != null) this.api.today();
    },
    next () {
      if(this.api != null) this.api.next();
    },
    prev () {
      if(this.api != null) this.api.prev();
    },
    renderNewEvents(data, bg = false){
      if(this.api != null) {
        if(!bg) this.api.getEvents().forEach(event => event.remove());
        data.forEach(e => {
          if(bg) {
            e.display = 'background';
            e.backgroundColor = undefined
          }
          this.api.addEvent (e)
        });
      }
    },
    updateCalendar(data = [], selectedCoworking = [], background = false){
      if(typeof data != 'object' || typeof selectedCoworking != 'object') return 0;
      let newEvents = data.filter((item)=>{
        return selectedCoworking.some(si => si == item.coworking_id)
      }).map((item)=>{
        item.backgroundColor = '#DBBFA7';
        return item
      })
      this.renderNewEvents(newEvents, background);
    },
    addEvent (form){
      this.api.addEvent({
        title: form.name,
        start: `${form.date}T${form.start}`,
        end:`${form.date}T${form.end}`,
        resourceId: form.resId,
        working: false,
        dnc: true,
        payed: false,
        borderColor: '#DBBFA7',
        backgroundColor: '#ffffff'
      })
    },
  },
}
</script>

<style lang="scss">
.calendar__wrap {
  position: relative;
  min-width: unset !important;
}

@media (max-width: 600px) {
  .fc-col-header-cell{
    display: none;
  }
}
.calendar__btn {
  background-color: #E5E5E5;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.04), 0 2px 6px rgba(0, 0, 0, 0.04), 0 0 1px rgba(0, 0, 0, 0.04);
  border-radius: 5px;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  position: absolute;
  left: 30px;
  top: 300px;
  transform: rotateY(0);
  z-index: 999;
  &.right {
    right: 0;
    left: auto;
    transform: rotateY(180deg);
  }
}
</style>
<style lang="scss">
  .MSCalendar {
    .fc {
      .fc-scroller-harness {
        overflow: visible;
      }
      .fc-scroller-liquid-absolute {
        overflow: visible !important;
      }
    }
  }
</style>
